export const UA_TOOLTIP_CLASS = 'ua-tooltip';
